import axiosClient from 'config/axiosClient';

const _url = '/Api/Evaluation';

const evaluationService = {
    getPaging: (option: any) => {
        return axiosClient.post(_url + '/GetPaging', option);
    },
    save: (option: any) => {
        return axiosClient.post(_url + '/Save', option);
    },
    saveDrl: (option: any) => {
        return axiosClient.post(_url + '/SaveDrl', option);
    },
    delete: (id: number) => {
        return axiosClient.post(_url + '/Delete', { id: id });
    },
    deleteDrl: (id: number) => {
        return axiosClient.post(_url + '/DeleteDrl', { id: id });
    },
    getPracticeEvaluation: (examId: string) => {
        return axiosClient.get(_url + `/GetPracticeEvaluation?examId=${examId}`);
    },
    duplicate: (option: { questionIdSrc: string; questionIdDes: string }) => {
        return axiosClient.post(_url + '/DuplicatePracticeQuestion', option);
    }
};

export default evaluationService;